import { setVersion } from './setVersion';
export { setVersion };
setVersion('@uifabric/set-version', '6.0.0');